import * as React from 'react';
import { Column } from "react-table";
import Table from "../../components/table/Table";
import { CLIENT_ROUTE, API_ROUTE, CLIENT_TITLE } from "./constants";
import TableIndicator from "../../components/common/TableStatus";
import type { ISection } from "./types";
import dayjs from "dayjs";
import Page from "../../components/layout/Page";
import { sectionTypes } from "./constants";
import { useListPage } from "../../hooks";
import CreateButton from "../../components/common/CreateButton";
import RowActions from "../../components/table/RowActions";

interface ISectionRecord extends Pick<ISection, 'code' | 'isActive' | 'itemTitle' | 'order' | 'title' | 'type' | '_id' | 'createdAt'> {
    actions: unknown;
}

const SectionList = () => {

    const { handleInteraction, records, deleteRecord, paginationState } = useListPage({
        apiRoute: API_ROUTE,
        clientRoute: CLIENT_ROUTE
    })

    const columns: Column<ISectionRecord>[] =  [
        {
            Header: 'Код',
            accessor: 'code',
        },
        {
            Header: 'Бүлгийн нэр',
            accessor: 'itemTitle',
            Cell(table) {
                const value = table.row.original.itemTitle;
                return (
                    <div>
                        {value ?? '-'}
                    </div>
                )
            }
        },
        {
            Header: 'Нэр',
            accessor: 'title',
        },
        {
            Header: 'Төрөл',
            accessor: 'type',
            Cell(table) {
                const value = table.row.original.type;
                const valueObj = sectionTypes.find(type => type.value === value);
                return (
                    <div>
                        {valueObj?.label ?? '-'}
                    </div>
                )
            }
        },
        {
            Header: 'Дараалал',
            accessor: 'order',
        },
        {
            Header: 'Төлөв',
            accessor: 'isActive',
            Cell: ({ value }) => {
                return <TableIndicator active={value}/>;
            },
            width: 1
        },
        {
            Header: 'Үүссэн огноо',
            accessor: 'createdAt',
            Cell: ({ value }) => {
                return (
                    <div>
                        {dayjs(value).format('YYYY.MM.DD HH:mm')}
                    </div>
                );
            }
        },
        {
            Header: '',
            accessor: 'actions',
            Cell: (table) => {
                return (
                    <RowActions id={table.row.original._id} deleteRecord={deleteRecord} clientRoute={CLIENT_ROUTE}/>
                )
            }
        },
    ];

    return (
        <Page>
            <Page.Header title={CLIENT_TITLE}>
                <CreateButton route={CLIENT_ROUTE}/>
            </Page.Header>
            <Page.Body>
                <Table
                    searchable
                    columns={columns}
                    data={records}
                    totalPages={paginationState.totalPage}
                    onInteraction={handleInteraction}
                />
            </Page.Body>
        </Page>
    )
};

export default SectionList;